import { Button, ListPage } from '@mgrvtechgroup/admin-ds';
import { ChevronRightIcon } from 'lucide-react';

/**
 * 하단 고정 페이지 바 — 운영 지점과 삭제된 지점 목록이 같이 쓴다.
 * 서버가 cursor만 줘서 "처음으로"와 "다음"만 있다(이전·번호 이동 없음). 이동할 곳이 없으면 아무것도 그리지 않는다.
 */
export function NativePropertyListPager({
  label,
  countText,
  canFirst,
  canNext,
  busy,
  onFirst,
  onNext,
}: {
  /** 이동 영역의 이름 — "지점 목록 페이지 이동". */
  label: string;
  /** 이 페이지에 보이는 수 — "15개 표시". */
  countText: string;
  canFirst: boolean;
  canNext: boolean;
  /** 다시 받는 중에는 이동 버튼을 잠근다. */
  busy: boolean;
  onFirst: () => void;
  onNext: () => void;
}) {
  if (!canFirst && !canNext) return null;
  return (
    <ListPage.Pagination className="border-t px-[var(--layout-gutter)] py-2">
      <nav aria-label={label} className="flex w-full flex-wrap items-center justify-between gap-3">
        <span className="caption text-muted-foreground tabular-nums" aria-live="polite">
          {countText}
        </span>
        <div className="flex items-center gap-2">
          {canFirst && (
            <Button variant="outline" disabled={busy} onClick={onFirst}>
              처음으로
            </Button>
          )}
          {canNext && (
            <Button variant="outline" disabled={busy} onClick={onNext}>
              다음
              <ChevronRightIcon aria-hidden />
            </Button>
          )}
        </div>
      </nav>
    </ListPage.Pagination>
  );
}
